import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observeYoutubeIframes();
  }

  observeYoutubeIframes() {
    const youtubeIframes = document.querySelectorAll(".multiple_youtube_iframe");
    if (youtubeIframes.length === 0) {
      return; // Exit if no YouTube links are present
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const iframe = entry.target;
          this.loadYoutubeIframe(iframe);
          observer.unobserve(iframe); // Stop observing once loaded
        }
      });
    });

    youtubeIframes.forEach((iframe) => observer.observe(iframe));
  }

  loadYoutubeIframe(iframe) {
    const youtubeId = iframe.getAttribute("data-youtube-id");
    if (!youtubeId) return;

    // Load the YouTube IFrame Player API script if not already loaded
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Wait for the API to be ready before initializing the player
      window.onYouTubeIframeAPIReady = () => {
        this.initializePlayer(iframe, youtubeId);
      };
    } else {
      this.initializePlayer(iframe, youtubeId);
    }
  }

  initializePlayer(iframe, youtubeId) {
    new YT.Player(iframe.id, {
      videoId: youtubeId,
    });
  }
}